import { createApi } from 'unsplash-js';
import { createClient as createPexelsClient } from 'pexels';
import { useImageSourceStore } from '../stores/imageSource';

const unsplash = createApi({
  accessKey: import.meta.env.VITE_UNSPLASH_ACCESS_KEY
});

const pexels = createPexelsClient(import.meta.env.VITE_PEXELS_API_KEY);

export const imageService = {
  async searchImages(query, perPage = 10) {
    const imageSourceStore = useImageSourceStore();
    const source = imageSourceStore.imageSource;

    try {
      if (source === 'unsplash') {
        const result = await unsplash.search.getPhotos({
          query,
          perPage,
          orientation: 'landscape'
        });

        if (result.errors) {
          throw new Error(result.errors[0]);
        }

        return result.response.results.map(photo => ({
          id: photo.id,
          description: photo.description || photo.alt_description,
          urls: photo.urls,
          user: photo.user,
          links: photo.links
        }));
      } else if (source === 'pexels') {
        const result = await pexels.photos.search({
          query,
          per_page: perPage,
          orientation: 'landscape'
        });

        return result.photos.map(photo => ({
          id: photo.id,
          description: photo.alt || photo.photographer,
          urls: {
            raw: photo.src.original,
            full: photo.src.large2x,
            regular: photo.src.large,
            small: photo.src.medium,
            thumb: photo.src.small
          },
          user: {
            name: photo.photographer,
            portfolio_url: photo.photographer_url
          },
          links: {
            html: photo.url
          }
        }));
      }

      throw new Error('Invalid image source');
    } catch (error) {
      console.error(`Error fetching images from ${source}:`, error);
      throw error;
    }
  }
}; 